import 'katex/dist/katex.min.css'
import MarkdownPage from "./MarkdownPage";

type RequisiteProps = {} & React.HTMLAttributes<HTMLDivElement>;

export default function RequisitePage({ children, ...props }: RequisiteProps) {
  return (
    <MarkdownPage group={"public"} message={"requisite"}></MarkdownPage>
  )
}
